import { PathName, getRouteByKey } from 'utility/routes';

import { AnchorLink } from 'components/anchorLink';
import { DashboardCms } from 'lib/datoCms/queries/getDashboardPage';
import { Wrapper } from 'components/wrapper';
import styles from './TableScommesseAperte.module.scss';
import { useGetLabelByKey } from 'hooks/useLingUI';
import { useMemo } from 'react';

export type TableScommesseAperteProps = {
  children?: React.ReactElement | React.ReactElement[];
  dashboardPage: DashboardCms;
};

export const TableScommesseAperte = ({ children, dashboardPage }: TableScommesseAperteProps) => {
  const labelButton = useGetLabelByKey('vedi-tutte');
  const myBetsUrl = useMemo(() => getRouteByKey(PathName.myBetsUrl), []);
  return (
    <Wrapper noPaddingTop noPaddingBottom noPaddingLeft noPaddingRight className="openBets">
      <div className={styles.headerTable}>
        <p className={styles.title}>{dashboardPage.labelScommesseAperte}</p>
        <AnchorLink href={myBetsUrl} className={styles.link}>
          <p>{labelButton}</p>
        </AnchorLink>
      </div>
      <div className={styles.container}>{children}</div>
    </Wrapper>
  );
};
